import HttpService from 'domovio-core/src/system/rest/rest.service';

export async function createDisposition(data) {
    return HttpService.post('/v1/dispositions', data);
}

export async function updateDisposition(data) {
    const { id } = data;
    delete data.id;
    return HttpService.put('/v1/dispositions/' + id, data);
}

export async function removeDisposition(id) {
    return HttpService.delete('/v1/dispositions/' + id).then(() => id);
}

export async function loadDispositions(projectId) {
    return HttpService.get('/v1/dispositions', { projectId });
}
